import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {GridOptions} from 'ag-grid/main';
import {HttpErrorResponse} from '@angular/common/http';
import {ProjectService} from '../../services/project.service';
import {Project} from '../../models/project.model';
import {SessionService} from '../../services/session.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  rollingProjectList: Array<Project> = [];
  allProjectList: Array<Project> = [];

  colDefs = [];
  gridOptions: GridOptions = {};
  searchText = '';

  constructor(protected toastr: ToastrService, private projectService: ProjectService, private router: Router) {
  }

  ngOnInit() {
    this.getProjects();
    this.initializeAGGridSettings();
  }

  /**
   * This function initializes the ag-grid options and column definitions
   */
  initializeAGGridSettings() {
    this.colDefs = [
      {
        headerName: 'Client',
        filter: 'text',
        minWidth: 25,
        maxWidth: 250,
        valueGetter: this.clientCodeAndName
      },
      {
        headerName: 'Project',
        filter: 'text',
        minWidth: 150,
        valueGetter: this.projectCodeAbdDesc
      },
      {
        headerName: 'Manager',
        field: 'Manager',
        filter: 'text',
        minWidth: 50,
        maxWidth: 200
      },
      {
        headerName: 'Country of Manager',
        field: 'ManagerCountry',
        filter: 'text',
        width: 25
      }
    ];
    this.gridOptions = <GridOptions>{
      columnDefs: this.colDefs,
      enableColResize: true,
      enableFilter: true,
      enableSorting: true,
      rowSelection: 'single',
      cacheQuickFilter: true,
      suppressHorizontalScroll: true,
      onModelUpdated: () => {
        this.gridOptions.api.sizeColumnsToFit();
      },
      onGridSizeChanged: () => {
        this.gridOptions.api.sizeColumnsToFit();
      }
    };
  }

  /**
   * function to handle clicks on AgGrid
   * Typically redirects to the Project's Health Wizard
   * @param params
   */
  onRowClicked(params) {
    SessionService.selectedProject = params.data;
    this.router.navigate(['/root/project-wizard', params.data.Client, params.data.Project]);

  }

  /**
   * functions to auto fit the column width.
   * Executed once grid is ready
   * @param params passed from the ag-grid gridReady event
   */
  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  clientCodeAndName(params) {
    return params.data.Client + ' - ' + params.data.ClientName;
  }

  projectCodeAbdDesc(params) {
    return params.data.Project + ' - ' + params.data.Description;
  }

  /**
   *Uses ProjectService to fetch rolling & all projects from Django API
   */
  getProjects() {
    this.projectService.getRollingProjects().subscribe((projectsList) => {
      this.rollingProjectList = projectsList;
    }, (err: HttpErrorResponse) => {
      console.log('Error :' + JSON.stringify(err));
      setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in RollingProject Retrieval : Code ' + err.status));
    });
    this.projectService.getAllProjects().subscribe((projectList) => {
      this.allProjectList = projectList;
    }, (err: HttpErrorResponse) => {
      console.log('Error :' + JSON.stringify(err));
      setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in AllProject Retrieval : Code ' + err.status));
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/components/dashboard/dashboard.component.ts